// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iviv","fullView":"styles_fullView__2wX6B"};